var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9257 5.99916L11.6132 0.411663C11.6918 0.318806 11.6257 0.177734 11.5043 0.177734H10.0793C9.99534 0.177734 9.91499 0.215234 9.85963 0.27952L5.99356 4.88845L2.12749 0.27952C2.07392 0.215234 1.99356 0.177734 1.90784 0.177734H0.482844C0.361415 0.177734 0.295344 0.318806 0.373915 0.411663L5.06142 5.99916L0.373915 11.5867C0.356315 11.6074 0.345023 11.6327 0.341381 11.6596C0.337739 11.6865 0.341899 11.7139 0.353368 11.7386C0.364837 11.7632 0.383133 11.784 0.406083 11.7985C0.429034 11.8131 0.455675 11.8207 0.482844 11.8206H1.90784C1.99177 11.8206 2.07213 11.7831 2.12749 11.7188L5.99356 7.10988L9.85963 11.7188C9.9132 11.7831 9.99356 11.8206 10.0793 11.8206H11.5043C11.6257 11.8206 11.6918 11.6795 11.6132 11.5867L6.9257 5.99916Z",
    fill: "var(--hig-color-black-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondCancel);
export default __webpack_public_path__ + "static/media/second-cancel.9ff214de.svg";
export { ForwardRef as ReactComponent };